
jQuery( document ).ready(function($) {
	
	//add/remove class based on scroll threshold
	// var $wrapperNavbar = $('#wrapper-navbar'); 
	// var scrollThreshold = 50; 
	// $(window).scroll(function() {
	// 	if ($(window).scrollTop() > scrollThreshold) {
	// 		if (!$wrapperNavbar.hasClass('is-stuck')) {
	// 			$wrapperNavbar.addClass('is-stuck');
	// 		}
	// 	} else {
	// 		if ($wrapperNavbar.hasClass('is-stuck')) {
	// 			$wrapperNavbar.removeClass('is-stuck');
	// 		}
	// 	}
	// });

	// $(window).trigger('scroll'); 

	//remove focus from modal on open
	$('.modal').on('shown.bs.modal', function (e) {
		let focusedElement = $(':focus');
		if (focusedElement.length) {
		  focusedElement.blur();
		}
	});
	//remove focus from modal on hide
	$('.modal').on('hide.bs.modal', function (e) {
		let focusedElement = $(':focus');
		if (focusedElement.length) {
		  focusedElement.blur();
		}

	});

	//check for #copyright
	if ($("#copyright").length > 0) {
		document.getElementById('copyright').appendChild(document.createTextNode(new Date().getFullYear()));
	} else {
		console.log("Element with ID 'copyright' does not exist.");
	}

});
